import {
  OFFER_HOLD_PRESETS,
  formatOfferHold,
  offerHoldSecondsToMinutes,
} from "../lib/offer-hold";

/**
 * Minutes-based picker for the unanswered Duty Call offer hold (stored as seconds on the policy).
 * Same shape as the duty ping interval picker: preset chips plus a custom-minutes select bounded
 * by the policy CHECK (60-3600 seconds).
 */
export function OfferHoldPicker({
  unansweredOfferHoldSeconds,
  onChange,
  disabled = false,
}: {
  unansweredOfferHoldSeconds: number;
  onChange: (seconds: number) => void;
  disabled?: boolean;
}) {
  const minutes = offerHoldSecondsToMinutes(unansweredOfferHoldSeconds);

  return (
    <fieldset className="tpl__fieldset ping-interval" disabled={disabled}>
      <legend className="tpl__legend">Hold length</legend>
      <p className="setup__field-hint">
        How long a directed Call offer waits for the officer before Dispatch closes it. The officer
        sees no countdown. Accept and Decline are unchanged.
      </p>
      <div className="shift-duration__presets" role="group" aria-label="Common offer holds">
        {OFFER_HOLD_PRESETS.map((preset) => (
          <button
            key={preset.seconds}
            type="button"
            className={`toggle-chip${
              unansweredOfferHoldSeconds === preset.seconds ? " toggle-chip--on" : ""
            }`}
            aria-pressed={unansweredOfferHoldSeconds === preset.seconds}
            onClick={() => onChange(preset.seconds)}
          >
            {preset.label}
          </button>
        ))}
      </div>
      <label className="tpl__field">
        Custom hold (minutes)
        <select
          value={minutes}
          onChange={(event) => onChange(Number(event.target.value) * 60)}
          aria-label="Offer hold minutes"
        >
          {Array.from({ length: 60 }, (_, index) => index + 1).map((value) => (
            <option key={value} value={value}>
              {value === 1 ? "1 minute" : `${value} minutes`}
            </option>
          ))}
        </select>
      </label>
      <p className="shift-duration__summary" role="status">
        <span className="shift-duration__summary-length">
          Holds for {formatOfferHold(unansweredOfferHoldSeconds)}
        </span>
      </p>
    </fieldset>
  );
}
